import React from 'react';
import { RuDiagramModal } from './RuDiagramModal';

export const RuMeasurementTypeModal = RuDiagramModal({
  title: 'Type of Measurement',
  content: (
    <div>
      Valid values:
      {' '}
      <b>1, 2, 3, 4, 5, 6, 7, 8, 9, 10 </b>
      <br />
      <i>See image and text below for more information.</i>
      <br />
      <br />
    </div>
  ),
});
